module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 143.c4054d9a.png";